/* ================================================
   AMERICANITOS · JavaScript
   América de Cali · 2026

   Gemelo de abonados.js pero con su propio namespace
   (AME) y sus propios IDs (ame-*), para que las dos
   secciones puedan convivir sin pisarse. Reutiliza
   las clases abe-* de abonados.css.

   Oct-2026 · cargue de documentos. Los archivos viajan
   en Base64 dentro del mismo POST y el Apps Script los
   guarda en una carpeta privada de Drive. Para que el
   envío quepa en datos móviles, cada foto se reduce en
   el teléfono (lado máximo 1600 px, JPEG) y las dos
   caras de un documento se unen en UNA sola imagen,
   como pide cumplimiento («un único archivo»).
   ================================================ */

window.AME = (function () {
  'use strict';

  /* Versión del backend que entiende este formulario. Si el Apps Script
     publicado es anterior, la inscripción se bloquea: el script viejo
     escribiría en la hoja del evento pasado y tiraría los documentos. */
  const BACKEND_VERSION = 2;

  const LADO_MAX   = 1600;              // px, lado mayor de cada foto
  const PDF_MAX    = 4 * 1024 * 1024;   // 4 MB
  const FINAL_MAX  = 3.5 * 1024 * 1024; // tope de la imagen ya unida

  const RH        = ['O+', 'O-', 'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-'];
  const PARENTESCO = ['Padre', 'Madre', 'Tutor', 'Familiar', 'Otro'];
  const TIPO_DOC  = { RC: 'Registro Civil de Nacimiento', TI: 'Tarjeta de Identidad' };

  /* ── Estado y configuración ──────────────────── */
  const cfg = { scriptUrl: '', cuposMax: 13, maxNinos: 5, token: '', evento: '' };

  const state = {
    step: 1,
    cupos: { confirmados: 0, restantes: 13, max: 13 },
    backendOk: true,
    submitting: false,
    cantNinos: 1,
  };

  /* Documentos adjuntos, por clave: 'acu', 'nino-1', 'nino-2'…
     { tipo: 'pdf', file, nombre }  ó  { tipo: 'img', caras: [{ canvas, thumb }] } */
  const docs = {};

  /* ── Init ──────────────────────────────────────── */
  async function init() {
    const section = document.getElementById('ame-form-section');
    if (!section) return;

    cfg.scriptUrl = section.dataset.scriptUrl || '';
    cfg.cuposMax  = parseInt(section.dataset.cuposMax) || 13;
    cfg.maxNinos  = parseInt(section.dataset.maxNinos) || 5;
    cfg.token     = section.dataset.token || '';
    cfg.evento    = section.dataset.evento || '';

    state.cupos.max = state.cupos.restantes = cfg.cuposMax;

    _setHeaderOffset();
    window.addEventListener('resize', _setHeaderOffset);

    // Los widgets de documento se enganchan por delegación: los de los niños
    // se repintan cada vez que cambia la cantidad.
    section.addEventListener('change', _onDocChange);
    section.addEventListener('click', _onDocClick);
    section.addEventListener('change', _onNacimientoChange);

    _pintarDoc(section.querySelector('.ame-doc[data-doc="acu"]'));
    selectCant(1);

    if (cfg.scriptUrl) {
      await _fetchCupos();
      _startCuposPolling();
    } else {
      // Modo demo: simula cupos parcialmente ocupados
      state.cupos = { confirmados: 5, restantes: cfg.cuposMax - 5, max: cfg.cuposMax };
      _renderCupos();
    }
  }

  /* ── Refresco periódico de cupos (15 s) ─────────── */
  let cuposInterval = null;

  function _startCuposPolling() {
    if (cuposInterval) return;
    cuposInterval = setInterval(function () {
      if (state.submitting || document.hidden) return;
      _fetchCupos();
    }, 15000);
  }

  function _stopCuposPolling() {
    if (cuposInterval) { clearInterval(cuposInterval); cuposInterval = null; }
  }

  /* ── Header offset para 100vh ───────────────────── */
  function _setHeaderOffset() {
    const sectionEl = document.getElementById('ame-form-section');
    if (!sectionEl) return;

    const candidates = [
      'header.sticky-header', 'sticky-header', '[class*="shopify-section-header"] header',
      '#shopify-section-header', '.site-header', 'header',
    ];

    let h = 0;
    for (const sel of candidates) {
      try {
        const el = document.querySelector(sel);
        if (el && el.offsetHeight > 0) { h = el.offsetHeight; break; }
      } catch (_) {}
    }
    sectionEl.style.setProperty('--abe-header-h', h + 'px');
  }

  /* ── Cupos ─────────────────────────────────────── */
  async function _fetchCupos() {
    try {
      const res  = await fetch(cfg.scriptUrl + '?action=getCuposAmericanitos');
      const data = await res.json();

      if (data.error || typeof data.confirmados !== 'number') {
        console.warn('[AME] La respuesta de cupos vino con error:', data.error || data);
        _renderCuposError();
        return;
      }

      state.backendOk = (data.version === BACKEND_VERSION);
      state.cupos = {
        confirmados: data.confirmados,
        restantes:   (typeof data.restantes === 'number') ? data.restantes : Math.max(0, cfg.cuposMax - data.confirmados),
        max:         data.max || cfg.cuposMax,
      };
    } catch (e) {
      console.warn('[AME] No se pudieron cargar los cupos:', e);
      _renderCuposError();
      return;
    }
    _renderCupos();
  }

  function _renderCuposError() {
    const badge = document.getElementById('ame-cupos-badge');
    if (!badge) return;
    badge.textContent = 'No se pudo verificar';
    badge.className = 'abe-cupos-badge abe-cupos-badge--low';
  }

  function _renderCupos() {
    const badge = document.getElementById('ame-cupos-badge');
    if (!badge) return;

    if (!state.backendOk) {
      badge.textContent = 'Inscripción en preparación';
      badge.className = 'abe-cupos-badge abe-cupos-badge--low';
      return;
    }

    const { restantes } = state.cupos;
    if (restantes <= 0) {
      badge.textContent = 'Llenos · lista de espera';
      badge.className = 'abe-cupos-badge abe-cupos-badge--full';
    } else if (restantes <= 4) {
      badge.textContent = restantes === 1 ? 'Queda 1' : 'Quedan ' + restantes;
      badge.className = 'abe-cupos-badge abe-cupos-badge--low';
    } else {
      badge.textContent = restantes + ' disponibles';
      badge.className = 'abe-cupos-badge';
    }
  }

  /* ── Navegación entre pasos ─────────────────────── */
  function goStep(n) {
    if (n > state.step && !_validate(state.step)) return;

    const prevPanel = document.getElementById('ame-panel-' + state.step);
    const nextPanel = document.getElementById('ame-panel-' + n);
    const prevDot   = document.getElementById('ame-step-'  + state.step);
    const nextDot   = document.getElementById('ame-step-'  + n);

    if (prevPanel) prevPanel.classList.remove('abe-panel--active');
    if (prevDot) {
      prevDot.classList.remove('abe-step--active');
      prevDot.classList.toggle('abe-step--done', n > state.step);
    }

    state.step = n;

    if (nextPanel) nextPanel.classList.add('abe-panel--active');
    if (nextDot)   { nextDot.classList.add('abe-step--active'); nextDot.classList.remove('abe-step--done'); }

    if (n === 3) { _buildSummary(); _pulseSubmitBtn(); }

    document.getElementById('ame-form-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Validaciones ───────────────────────────────── */
  function _markError(el) {
    if (!el) return;
    el.classList.add('abe-field-error');
    const evt = (el.type === 'checkbox' || el.tagName === 'SELECT' || el.type === 'date') ? 'change' : 'input';
    el.addEventListener(evt, function () { el.classList.remove('abe-field-error'); }, { once: true });
  }

  function _shake(sel) {
    const btn = document.querySelector(sel);
    if (!btn) return;
    btn.classList.add('abe-btn-shake');
    setTimeout(function () { btn.classList.remove('abe-btn-shake'); }, 400);
  }

  // Lleva la vista al primer campo con error: con 5 niños el formulario es
  // largo y el error puede quedar muy por encima del botón.
  function _irAlPrimerError(panelId) {
    const el = document.querySelector('#' + panelId + ' .abe-field-error, #' + panelId + ' .ame-doc--error');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function _validate(step) {
    if (step === 1) {
      var valid = true;

      ['ame-acu-nombre', 'ame-acu-cedula', 'ame-acu-celular', 'ame-acu-email',
       'ame-acu-ciudad', 'ame-acu-direccion'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || !el.value.trim()) { valid = false; _markError(el); }
      });

      var ced = document.getElementById('ame-acu-cedula');
      if (ced && ced.value.trim() && ced.value.replace(/\D/g, '').length < 6) { valid = false; _markError(ced); }

      var mail = document.getElementById('ame-acu-email');
      if (mail && mail.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.value.trim())) {
        valid = false; _markError(mail);
      }

      if (!_docCompleto('acu', true)) valid = false;

      var consent = document.getElementById('ame-consent');
      if (!consent || !consent.checked) { valid = false; _markError(consent); }

      if (!valid) { _shake('#ame-btn-step1'); _irAlPrimerError('ame-panel-1'); }
      return valid;
    }

    if (step === 2) {
      var ok = true;

      for (var i = 1; i <= state.cantNinos; i++) {
        ['nombre', 'nac', 'tipodoc', 'numdoc', 'eps', 'rh', 'parentesco', 'talla'].forEach(function (f) {
          var el = document.getElementById('ame-nino-' + i + '-' + f);
          if (!el || !el.value.trim()) { ok = false; _markError(el); }
        });

        var nac  = document.getElementById('ame-nino-' + i + '-nac');
        var edad = _edad(nac ? nac.value : '');
        if (nac && nac.value && (edad === null || edad < 0 || edad >= 18)) { ok = false; _markError(nac); }

        if (!_docCompleto('nino-' + i, true)) ok = false;
      }

      if (!ok) { _shake('#ame-panel-2 .abe-btn-primary'); _irAlPrimerError('ame-panel-2'); }
      return ok;
    }

    return true;
  }

  /* ── Edad ───────────────────────────────────────── */
  // Años cumplidos a hoy. null si la fecha no es válida o es futura.
  function _edad(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || '')) return null;
    var p = iso.split('-').map(Number);
    var hoy = new Date();
    var nac = new Date(p[0], p[1] - 1, p[2]);
    if (isNaN(nac) || nac > hoy) return null;
    var e = hoy.getFullYear() - p[0];
    if (hoy.getMonth() + 1 < p[1] || (hoy.getMonth() + 1 === p[1] && hoy.getDate() < p[2])) e--;
    return e;
  }

  function _onNacimientoChange(ev) {
    var t = ev.target;
    var m = t.id && t.id.match(/^ame-nino-(\d+)-nac$/);
    if (!m) return;
    var i = m[1];
    var e = _edad(t.value);
    var out = document.getElementById('ame-nino-' + i + '-edad');
    if (out) out.value = (e === null) ? '' : (e + (e === 1 ? ' año' : ' años'));

    // Sugiere el documento según la edad (TI desde los 7), sin pisar una elección
    var tipo = document.getElementById('ame-nino-' + i + '-tipodoc');
    if (tipo && !tipo.value && e !== null) {
      tipo.value = (e >= 7) ? 'TI' : 'RC';
      _actualizarCarasNino(i);
    }
  }

  /* ── Pulso del botón al entrar al paso 3 ─────────── */
  function _pulseSubmitBtn() {
    var btn = document.getElementById('ame-submit-btn');
    if (!btn) return;
    btn.classList.remove('abe-btn-pulse');
    void btn.offsetWidth;
    btn.classList.add('abe-btn-pulse');
    setTimeout(function () { btn.classList.remove('abe-btn-pulse'); }, 3200);
  }

  /* ── Cantidad de niños ──────────────────────────── */
  function selectCant(n) {
    if (state.submitting) return;

    var previos = _leerNinos();

    n = Math.min(Math.max(1, n), cfg.maxNinos);
    state.cantNinos = n;

    var numEl = document.getElementById('ame-cant-num');
    if (numEl) numEl.textContent = n;

    var dec = document.querySelector('#ame-panel-2 .abe-cant-dec');
    if (dec) dec.disabled = (n <= 1);
    var inc = document.querySelector('#ame-panel-2 .abe-cant-inc');
    if (inc) inc.disabled = (n >= cfg.maxNinos);

    _renderNinos(n, previos);
  }

  function adjustCant(delta) {
    selectCant(state.cantNinos + delta);
  }

  const CAMPOS_NINO = ['nombre', 'nac', 'tipodoc', 'numdoc', 'eps', 'rh', 'parentesco', 'talla', 'obs'];

  function _leerNinos() {
    var out = [];
    for (var i = 1; i <= state.cantNinos; i++) {
      var n = {};
      CAMPOS_NINO.forEach(function (f) { n[f] = _val('ame-nino-' + i + '-' + f); });
      out.push(n);
    }
    return out;
  }

  function _val(id) {
    var el = document.getElementById(id);
    return el ? el.value : '';
  }

  function _opciones(lista, elegido, vacio) {
    var html = '<option value="" disabled' + (elegido ? '' : ' selected') + '>' + _esc(vacio) + '</option>';
    lista.forEach(function (o) {
      var v = Array.isArray(o) ? o[0] : o;
      var t = Array.isArray(o) ? o[1] : o;
      html += '<option value="' + _esc(v) + '"' + (elegido === v ? ' selected' : '') + '>' + _esc(t) + '</option>';
    });
    return html;
  }

  function _campo(clase, id, label, control) {
    return '<div class="abe-field ' + clase + '">' +
      '<label for="' + id + '">' + label + '</label>' + control + '</div>';
  }

  function _renderNinos(count, previos) {
    var container = document.getElementById('ame-ninos');
    if (!container) return;
    container.innerHTML = '';

    var tallas = (document.getElementById('ame-form-section')?.dataset.tallas || '4,6,8,10,12,14,16')
      .split(',').map(function (t) { return t.trim(); }).filter(Boolean);

    var hoy = new Date();
    var maxFecha = hoy.toISOString().slice(0, 10);

    for (var i = 1; i <= count; i++) {
      var p = previos[i - 1] || {};
      var id = function (f) { return 'ame-nino-' + i + '-' + f; };
      var edad = _edad(p.nac);

      var card = document.createElement('div');
      card.className = 'abe-companion-card ame-nino-card';
      card.id = 'ame-nino-card-' + i;
      card.style.animationDelay = ((i - 1) * 70) + 'ms';
      card.innerHTML =
        '<div class="abe-companion-header">' +
          '<span class="abe-companion-num">' + (i < 10 ? '0' + i : String(i)) + '</span>' +
          '<span class="abe-companion-title">Americanito ' + i + '</span>' +
        '</div>' +
        '<div class="abe-field-grid abe-companion-grid">' +
          _campo('abe-field--full', id('nombre'), 'Nombre completo',
            '<input type="text" id="' + id('nombre') + '" placeholder="Nombres y apellidos" autocomplete="off" value="' + _esc(p.nombre) + '">') +
          _campo('', id('nac'), 'Fecha de nacimiento',
            '<input type="date" id="' + id('nac') + '" max="' + maxFecha + '" value="' + _esc(p.nac) + '">') +
          _campo('', id('edad'), 'Edad',
            '<input type="text" id="' + id('edad') + '" readonly tabindex="-1" class="ame-edad" placeholder="Se calcula sola" value="' +
              (edad === null ? '' : edad + (edad === 1 ? ' año' : ' años')) + '">') +
          _campo('', id('tipodoc'), 'Tipo de documento',
            '<select id="' + id('tipodoc') + '">' + _opciones([['RC', 'Registro Civil'], ['TI', 'Tarjeta de Identidad']], p.tipodoc, 'Selecciona') + '</select>') +
          _campo('', id('numdoc'), 'Número de documento',
            '<input type="text" id="' + id('numdoc') + '" inputmode="numeric" placeholder="Sin puntos" autocomplete="off" value="' + _esc(p.numdoc) + '">') +
          _campo('', id('eps'), 'EPS',
            '<input type="text" id="' + id('eps') + '" list="ame-eps-lista" placeholder="Escribe o elige" autocomplete="off" value="' + _esc(p.eps) + '">') +
          _campo('', id('rh'), 'Grupo sanguíneo (RH)',
            '<select id="' + id('rh') + '">' + _opciones(RH, p.rh, 'Selecciona') + '</select>') +
          _campo('', id('parentesco'), 'Parentesco contigo',
            '<select id="' + id('parentesco') + '">' + _opciones(PARENTESCO, p.parentesco, 'Selecciona') + '</select>') +
          _campo('', id('talla'), 'Talla de camiseta',
            '<select id="' + id('talla') + '">' + _opciones(tallas, p.talla, 'Selecciona') + '</select>') +
          '<div class="abe-field abe-field--full">' +
            '<div class="ame-doc" data-doc="nino-' + i + '" data-caras="' + (p.tipodoc === 'TI' ? 2 : 1) + '">' +
              '<span class="ame-doc-lbl">Registro civil o tarjeta de identidad</span>' +
              '<p class="ame-doc-hint">' + _hintNino(p.tipodoc) + '</p>' +
              '<div class="ame-doc-items"></div>' +
              '<label class="ame-doc-btn">' +
                '<input type="file" accept="image/*,application/pdf" class="ame-doc-input">' +
                '<span class="ame-doc-btn-txt">Adjuntar foto o PDF</span>' +
              '</label>' +
              '<p class="ame-doc-err" role="alert"></p>' +
            '</div>' +
          '</div>' +
          _campo('abe-field--full', id('obs'), 'Observaciones <span class="ame-opcional">(opcional)</span>',
            '<textarea id="' + id('obs') + '" rows="2" class="ame-textarea" ' +
              'placeholder="Alergias, condición médica o algo que debamos saber">' + _esc(p.obs) + '</textarea>') +
        '</div>';
      container.appendChild(card);

      card.querySelector('#' + id('tipodoc')).addEventListener('change', (function (n) {
        return function () { _actualizarCarasNino(n); };
      }(i)));

      _pintarDoc(card.querySelector('.ame-doc'));
    }
  }

  function _hintNino(tipo) {
    if (tipo === 'TI') return 'Tarjeta de identidad: una foto de cada cara o un solo PDF.';
    if (tipo === 'RC') return 'Registro civil: una foto o un PDF. Que se lea bien.';
    return 'Una foto o un PDF. Si es tarjeta de identidad, las dos caras.';
  }

  function _actualizarCarasNino(i) {
    var w = document.querySelector('.ame-doc[data-doc="nino-' + i + '"]');
    if (!w) return;
    var tipo = _val('ame-nino-' + i + '-tipodoc');
    w.dataset.caras = (tipo === 'TI') ? 2 : 1;
    var h = w.querySelector('.ame-doc-hint');
    if (h) h.textContent = _hintNino(tipo);
    _pintarDoc(w);
  }

  /* ── Documentos ─────────────────────────────────── */
  function _onDocClick(ev) {
    var btn = ev.target.closest('.ame-doc-quitar');
    if (!btn) return;
    var w = btn.closest('.ame-doc');
    var key = w.dataset.doc;
    var idx = parseInt(btn.dataset.idx, 10);
    var d = docs[key];
    if (d && d.tipo === 'img' && d.caras.length > 1) d.caras.splice(idx, 1);
    else delete docs[key];
    _pintarDoc(w);
  }

  async function _onDocChange(ev) {
    var input = ev.target;
    if (!input.classList || !input.classList.contains('ame-doc-input')) return;
    var file = input.files && input.files[0];
    input.value = ''; // permite volver a elegir el mismo archivo
    if (!file) return;

    var w = input.closest('.ame-doc');
    var key = w.dataset.doc;
    _docError(w, '');

    var esPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
    if (esPdf) {
      if (file.size > PDF_MAX) { _docError(w, 'Ese PDF pesa más de 4 MB. Mándalo como foto o en un PDF más liviano.'); return; }
      docs[key] = { tipo: 'pdf', file: file, nombre: file.name };
      _pintarDoc(w);
      return;
    }

    if (!/^image\//.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
      _docError(w, 'Sólo fotos o PDF.'); return;
    }

    w.classList.add('ame-doc--cargando');
    try {
      var canvas = await _reducir(file);
      var d = docs[key];
      if (!d || d.tipo !== 'img') d = docs[key] = { tipo: 'img', caras: [] };
      if (d.caras.length >= 2) d.caras = d.caras.slice(0, 1);
      d.caras.push({ canvas: canvas, thumb: canvas.toDataURL('image/jpeg', 0.5) });
    } catch (e) {
      _docError(w, 'No pudimos leer esa foto. Tómala de nuevo (formato JPG) o súbela en PDF.');
    }
    w.classList.remove('ame-doc--cargando');
    _pintarDoc(w);
  }

  // Dibuja la foto en un canvas de lado máximo LADO_MAX. El navegador ya
  // aplica la orientación EXIF al decodificar (foto de lado en el móvil).
  function _reducir(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var esc = Math.min(1, LADO_MAX / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width  = Math.round(img.naturalWidth * esc);
        c.height = Math.round(img.naturalHeight * esc);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  function _docError(w, msg) {
    var e = w.querySelector('.ame-doc-err');
    if (e) e.textContent = msg;
    w.classList.toggle('ame-doc--error', !!msg);
  }

  function _pintarDoc(w) {
    if (!w) return;
    var d = docs[w.dataset.doc];
    var caras = parseInt(w.dataset.caras, 10) || 1;
    var items = w.querySelector('.ame-doc-items');
    var btnTxt = w.querySelector('.ame-doc-btn-txt');
    var btn = w.querySelector('.ame-doc-btn');
    var html = '';

    if (d && d.tipo === 'pdf') {
      html = '<div class="ame-doc-item ame-doc-item--pdf"><span class="ame-doc-pdf">PDF</span>' +
        '<span class="ame-doc-nombre">' + _esc(d.nombre) + '</span>' +
        '<button type="button" class="ame-doc-quitar" data-idx="0">Quitar</button></div>';
    } else if (d && d.tipo === 'img') {
      d.caras.forEach(function (c, i) {
        html += '<div class="ame-doc-item"><img src="' + c.thumb + '" alt="">' +
          '<span class="ame-doc-nombre">' + (caras > 1 ? (i === 0 ? 'Frente' : 'Reverso') : 'Foto') + '</span>' +
          '<button type="button" class="ame-doc-quitar" data-idx="' + i + '">Quitar</button></div>';
      });
    }
    items.innerHTML = html;

    var completo = d && (d.tipo === 'pdf' || d.caras.length >= caras);
    btn.hidden = !!completo;
    if (btnTxt) btnTxt.textContent = (d && d.tipo === 'img') ? 'Añadir el reverso' : 'Adjuntar foto o PDF';
    w.classList.toggle('ame-doc--ok', !!completo);
    if (completo) _docError(w, '');
  }

  function _docCompleto(key, marcar) {
    var w = document.querySelector('.ame-doc[data-doc="' + key + '"]');
    if (!w) return false;
    var d = docs[key];
    var caras = parseInt(w.dataset.caras, 10) || 1;
    if (d && (d.tipo === 'pdf' || d.caras.length >= caras)) return true;
    if (marcar) {
      _docError(w, !d ? 'Falta adjuntar el documento.' : 'Falta la foto del reverso.');
    }
    return false;
  }

  // Une las caras en una sola imagen (una debajo de la otra) y la devuelve
  // como { nombre, mime, data } con data en Base64 sin cabecera.
  async function _empaquetarDoc(key, base) {
    var d = docs[key];
    if (!d) return null;

    if (d.tipo === 'pdf') {
      return { nombre: base + '.pdf', mime: 'application/pdf', data: await _base64(d.file) };
    }

    var cs = d.caras.map(function (c) { return c.canvas; });
    var ancho = Math.max.apply(null, cs.map(function (c) { return c.width; }));
    var sep = cs.length > 1 ? 24 : 0;
    var alto = cs.reduce(function (s, c) { return s + Math.round(c.height * ancho / c.width); }, 0) + sep * (cs.length - 1);

    var out = document.createElement('canvas');
    out.width = ancho; out.height = alto;
    var ctx = out.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, ancho, alto);
    var y = 0;
    cs.forEach(function (c) {
      var h = Math.round(c.height * ancho / c.width);
      ctx.drawImage(c, 0, y, ancho, h);
      y += h + sep;
    });

    var blob = null;
    for (var q of [0.82, 0.7, 0.58]) {
      blob = await new Promise(function (r) { out.toBlob(r, 'image/jpeg', q); });
      if (blob && blob.size <= FINAL_MAX) break;
    }
    return { nombre: base + '.jpg', mime: 'image/jpeg', data: await _base64(blob) };
  }

  function _base64(blob) {
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(String(fr.result).split(',')[1] || ''); };
      fr.onerror = reject;
      fr.readAsDataURL(blob);
    });
  }

  /* ── Escape de HTML — los datos los escribe el usuario ── */
  function _esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function _fechaLarga(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || '')) return '—';
    var p = iso.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }

  /* ── Resumen (paso 3) ───────────────────────────── */
  function _buildSummary() {
    var el = document.getElementById('ame-summary');
    if (!el) return;

    var get = function (id) {
      var e = document.getElementById(id);
      return (e && e.value.trim()) ? e.value.trim() : '—';
    };
    var docTxt = function (key) {
      var d = docs[key];
      if (!d) return '—';
      return d.tipo === 'pdf' ? 'PDF adjunto' : (d.caras.length > 1 ? '2 fotos adjuntas' : 'Foto adjunta');
    };

    function rowsHtml(rows) {
      return rows.map(function (r) {
        return '<div class="abe-confirm-row">' +
          '<span class="abe-confirm-key">' + _esc(r[0]) + '</span>' +
          '<span class="abe-confirm-val">' + _esc(r[1]) + '</span>' +
          '</div>';
      }).join('');
    }

    var html = '<div class="abe-confirm-group">' +
      '<div class="abe-confirm-group-hdr"><span>Acudiente</span>' +
      '<span class="abe-confirm-group-num">01</span></div>' +
      rowsHtml([
        ['Nombre',    get('ame-acu-nombre')],
        ['Cédula',    get('ame-acu-cedula')],
        ['Celular',   get('ame-acu-celular')],
        ['Correo',    get('ame-acu-email')],
        ['Residencia', get('ame-acu-direccion') + ', ' + get('ame-acu-ciudad')],
        ['Cédula adjunta', docTxt('acu')],
        ['Partido',   cfg.evento],
      ]) +
      '</div>';

    for (var i = 1; i <= state.cantNinos; i++) {
      var num = (i + 1) < 10 ? '0' + (i + 1) : String(i + 1);
      var tipo = get('ame-nino-' + i + '-tipodoc');
      var filas = [
        ['Nombre',       get('ame-nino-' + i + '-nombre')],
        ['Nacimiento',   _fechaLarga(_val('ame-nino-' + i + '-nac')) + ' · ' + get('ame-nino-' + i + '-edad')],
        ['Documento',    (TIPO_DOC[tipo] || tipo) + ' ' + get('ame-nino-' + i + '-numdoc')],
        ['EPS · RH',     get('ame-nino-' + i + '-eps') + ' · ' + get('ame-nino-' + i + '-rh')],
        ['Parentesco',   get('ame-nino-' + i + '-parentesco')],
        ['Talla',        get('ame-nino-' + i + '-talla')],
        ['Documento adjunto', docTxt('nino-' + i)],
      ];
      var obs = get('ame-nino-' + i + '-obs');
      if (obs !== '—') filas.push(['Observaciones', obs]);

      html += '<div class="abe-confirm-group abe-confirm-group--comp">' +
        '<div class="abe-confirm-group-hdr"><span>Americanito ' + i + '</span>' +
        '<span class="abe-confirm-group-num">' + num + '</span></div>' +
        rowsHtml(filas) +
        '</div>';
    }

    if (state.cupos.restantes < state.cantNinos) {
      html += '<div class="abe-confirm-warning">Los cupos están casi llenos. ' +
        'Si envías esta inscripción, tu grupo podría quedar en <strong>lista de espera</strong>.</div>';
    }

    el.innerHTML = html;
  }

  /* ── Submit ─────────────────────────────────────── */
  async function submitForm() {
    if (state.submitting) return;

    var imagen = document.getElementById('ame-aut-imagen');
    var condicion = document.getElementById('ame-decl-condicion');
    var faltan = false;
    if (!imagen.checked)    { _markError(imagen); faltan = true; }
    if (!condicion.checked) { _markError(condicion); faltan = true; }
    if (faltan) {
      _shake('#ame-submit-btn');
      _resetSubmit(null, 'Marca las dos casillas para confirmar la inscripción.');
      return;
    }

    if (cfg.scriptUrl && !state.backendOk) {
      _resetSubmit(null, 'La inscripción todavía no está abierta. Intenta de nuevo en unos minutos.');
      return;
    }

    state.submitting = true;
    const btn = document.getElementById('ame-submit-btn');
    if (btn) { btn.disabled = true; btn.classList.add('abe-btn-loading'); btn.textContent = 'Enviando documentos…'; }
    const pb = document.getElementById('ame-progress-bar');
    if (pb) pb.classList.add('abe-progress--active');

    var cedulaAcu = _val('ame-acu-cedula').replace(/\D/g, '');
    var payload;
    try {
      var ninos = [];
      for (var i = 1; i <= state.cantNinos; i++) {
        var numdoc = _val('ame-nino-' + i + '-numdoc').trim();
        ninos.push({
          nombre:     _val('ame-nino-' + i + '-nombre').trim(),
          nacimiento: _val('ame-nino-' + i + '-nac'),
          tipoDoc:    _val('ame-nino-' + i + '-tipodoc'),
          numDoc:     numdoc,
          eps:        _val('ame-nino-' + i + '-eps').trim(),
          rh:         _val('ame-nino-' + i + '-rh'),
          parentesco: _val('ame-nino-' + i + '-parentesco'),
          talla:      _val('ame-nino-' + i + '-talla').trim(),
          obs:        _val('ame-nino-' + i + '-obs').trim(),
          documento:  await _empaquetarDoc('nino-' + i, 'menor-' + i + '_' + numdoc.replace(/[^\w-]/g, '')),
        });
      }

      payload = {
        form: 'americanitos',
        acudiente: {
          nombre:    _val('ame-acu-nombre').trim(),
          cedula:    _val('ame-acu-cedula').trim(),
          celular:   _val('ame-acu-celular').trim(),
          email:     _val('ame-acu-email').trim(),
          ciudad:    _val('ame-acu-ciudad').trim(),
          direccion: _val('ame-acu-direccion').trim(),
          documento: await _empaquetarDoc('acu', 'acudiente_' + cedulaAcu),
        },
        ninos:            ninos,
        autorizacion:     !!document.getElementById('ame-consent')?.checked,
        autorizaImagen:   imagen.checked,
        declaraCondicion: condicion.checked,
        timestamp:        new Date().toISOString(),
        _token:           cfg.token,
      };
    } catch (e) {
      _resetSubmit(btn, 'No pudimos preparar los documentos. Vuelve a adjuntarlos e intenta de nuevo.');
      return;
    }

    if (cfg.scriptUrl) {
      try {
        const res  = await fetch(cfg.scriptUrl, {
          method:  'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body:    JSON.stringify(payload),
        });
        const texto = await res.text();
        let data;
        try { data = JSON.parse(texto); }
        catch (_) {
          // Respuesta que no es JSON = el script respondió con su página de error
          console.warn('[AME] Respuesta no JSON:', texto.slice(0, 300));
          _resetSubmit(btn, 'El servidor no pudo procesar la inscripción. Intenta de nuevo en unos minutos.');
          return;
        }

        if (data.error) { _resetSubmit(btn, data.error); return; }

        if (typeof data.cuposRestantes === 'number') {
          state.cupos.restantes   = data.cuposRestantes;
          state.cupos.confirmados = state.cupos.max - data.cuposRestantes;
          _renderCupos();
        }
        _stopCuposPolling();
        _showSuccess(data.codigo, data.estado, data.totalNinos);
      } catch (e) {
        _resetSubmit(btn, 'Se cortó la conexión mientras se enviaban los documentos. Revisa tu señal e intenta de nuevo.');
      }
    } else {
      await new Promise(r => setTimeout(r, 900));
      console.info('[AME] Modo demo · payload', payload);
      _showSuccess('DEMO-' + Date.now().toString(36).toUpperCase().slice(-6), 'Confirmado', state.cantNinos);
    }
  }

  function _resetSubmit(btn, msg) {
    state.submitting = false;
    if (btn) { btn.disabled = false; btn.classList.remove('abe-btn-loading'); btn.textContent = 'Confirmar inscripción'; }

    const pb = document.getElementById('ame-progress-bar');
    if (pb) pb.classList.remove('abe-progress--active');

    const errEl = document.getElementById('ame-submit-error');
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
      clearTimeout(_resetSubmit._t);
      _resetSubmit._t = setTimeout(function () { errEl.style.display = 'none'; }, 8000);
    }
  }

  function _showSuccess(codigo, estado, totalNinos) {
    const pb = document.getElementById('ame-progress-bar');
    if (pb) pb.classList.remove('abe-progress--active');

    document.getElementById('ame-panel-3')?.classList.remove('abe-panel--active');
    document.getElementById('ame-step-3')?.classList.add('abe-step--done');

    const success = document.getElementById('ame-success');
    if (success) success.classList.add('abe-success--active');

    const codeEl = document.getElementById('ame-success-code');
    if (codeEl) codeEl.textContent = 'CÓDIGO: ' + (codigo || '—');

    const titleEl = document.querySelector('#ame-success .abe-success-title');
    const subEl   = document.querySelector('#ame-success .abe-success-sub');
    const n       = totalNinos || state.cantNinos;
    const plural  = n === 1 ? 'tu Americanito quedó inscrito' : 'tus ' + n + ' Americanitos quedaron inscritos';

    if (estado && estado !== 'Confirmado') {
      if (titleEl) titleEl.textContent = 'Quedaste en lista de espera';
      if (subEl)   subEl.textContent = 'Los cupos están llenos. Te contactamos al celular registrado si se libera un espacio.';
    } else {
      if (titleEl) titleEl.textContent = '¡Listo, acudiente!';
      if (subEl)   subEl.textContent = 'Recibimos los datos y los documentos: ' + plural + '. Guarda este código; te contactamos al celular registrado con los detalles del ingreso.';
    }

    document.getElementById('ame-form-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── API pública ────────────────────────────────── */
  return { init, goStep, submitForm, selectCant, adjustCant };
}());

document.addEventListener('DOMContentLoaded', AME.init);
